// extracted by mini-css-extract-plugin
export default {"slide":"Side_slide__m4rjs","container":"Side_container__2nbqq"};